import { FC } from 'react';

interface UnderlineIconProps {
  color?: string;
  size?: string;
  className?: string;
}

export const UnderlineIcon: FC<UnderlineIconProps> = ({ color = 'currentColor', size = '16', className, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M3.97461 12.0471H11.9746C12.1611 12.0471 12.3398 12.1213 12.4717 12.2532C12.6035 12.385 12.6777 12.5638 12.6777 12.7502C12.6777 12.9366 12.6035 13.1155 12.4717 13.2473C12.3398 13.3791 12.161 13.4534 11.9746 13.4534H3.97461C3.78819 13.4534 3.60939 13.3791 3.47754 13.2473C3.34574 13.1155 3.27155 12.9366 3.27148 12.7502C3.27148 12.5638 3.34575 12.385 3.47754 12.2532C3.6094 12.1213 3.78813 12.0471 3.97461 12.0471ZM11.4746 2.31177C11.6611 2.31177 11.8398 2.38596 11.9717 2.51782C12.1035 2.64968 12.1777 2.82841 12.1777 3.01489V6.51489L12.1719 6.7229C12.1194 7.7615 11.6841 8.74678 10.9453 9.4856C10.1573 10.2736 9.08899 10.7169 7.97461 10.718L7.7666 10.7122C6.728 10.6597 5.74272 10.2244 5.00391 9.4856C4.21592 8.69761 3.77264 7.62927 3.77148 6.51489V3.01489C3.77148 2.82841 3.84568 2.64968 3.97754 2.51782C4.1094 2.38596 4.28813 2.31177 4.47461 2.31177C4.66109 2.31177 4.83982 2.38596 4.97168 2.51782C5.10354 2.64968 5.17773 2.82841 5.17773 3.01489V6.51489C5.17773 7.25667 5.47255 7.96792 5.99707 8.49243C6.52159 9.01695 7.23283 9.31177 7.97461 9.31177C8.71639 9.31177 9.42763 9.01695 9.95215 8.49243C10.4767 7.96792 10.7715 7.25667 10.7715 6.51489V3.01489C10.7715 2.82841 10.8457 2.64968 10.9775 2.51782C11.1094 2.38596 11.2881 2.31177 11.4746 2.31177Z"
      fill={color}
      stroke={color}
      strokeWidth="0.09375"
    />
  </svg>
);
